<template>
  <div class="pre-register-form">
    <section
      :class="
        !getPreRegistrationTypes
          ? 'no-usr-pre-reg-head-tab1'
          : 'pre-reg-head-tab1'
      "
    >
      <div class="visit-register-header">
        <div class="logo">
          <img src="@/assets/images/logo-lg.svg" alt="-visipoint-logo" />
        </div>
      </div>
      <h3 class="welcome-msg">{{ $t('common.welcome') }}</h3>
      <div v-if="getPreRegistrationTypes && getPreRegistrationTypes.length > 0">
        <p class="reg-msg-tab1">{{ $t('common.registerVisit') }}</p>
      </div>
    </section>
    <div v-if="getPreRegistrationTypes && getPreRegistrationTypes.length > 0">
      <p class="select-type-msg">{{ $t('integrations.selectUserType')}}</p>
      <div class="btns-grid">
        <b-button
          v-for="type in getPreRegistrationTypes"
          :key="type.id"
          @click="handelClick(type)"
          pill
          :variant="toggleValue == type.id ? 'dark' : 'light'"
          >{{ type.name }}
        </b-button>
      </div>
      <div
        class="h-line-tab1"
        v-if="getPreRegistrationTypes && getPreRegistrationTypes.length > 0"
      ></div>
      <section>
        <div style="margin-bottom: 66px">
          <p class="date-time-lable">{{ $t('common.visitDateAndTime') }}</p>
          <div class="date-piker-wrapper">
            <div class="date-time-wrappers date-p">
              <date-picker
                id="visit_date"
                class="pre-reg-datepicker"
                :class="dateValidation ? 'is-invalid' : ''"
                :first-day-of-week="1"
                v-model="dateValue"
                :placeholder="$t('addExpectedVisitor.visitDate')"
                value-type="date"
                format="DD/MM/YYYY"
                :disabledDate="disableDateBeforeCurrent"
              >
                <i slot="icon-calendar" v-if="!dateValue">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.666656 14.8332C0.666656 16.2498 1.74999 17.3332 3.16666 17.3332H14.8333C16.25 17.3332 17.3333 16.2498 17.3333 14.8332V8.1665H0.666656V14.8332ZM14.8333 2.33317H13.1667V1.49984C13.1667 0.999837 12.8333 0.666504 12.3333 0.666504C11.8333 0.666504 11.5 0.999837 11.5 1.49984V2.33317H6.49999V1.49984C6.49999 0.999837 6.16666 0.666504 5.66666 0.666504C5.16666 0.666504 4.83332 0.999837 4.83332 1.49984V2.33317H3.16666C1.74999 2.33317 0.666656 3.4165 0.666656 4.83317V6.49984H17.3333V4.83317C17.3333 3.4165 16.25 2.33317 14.8333 2.33317Z"
                      fill="#787878"
                    />
                  </svg>
                </i>
                <i slot="icon-calendar" v-if="dateValue">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.666626 14.8327C0.666626 16.2493 1.74996 17.3327 3.16663 17.3327H14.8333C16.25 17.3327 17.3333 16.2493 17.3333 14.8327V8.16602H0.666626V14.8327ZM14.8333 2.33268H13.1666V1.49935C13.1666 0.999349 12.8333 0.666016 12.3333 0.666016C11.8333 0.666016 11.5 0.999349 11.5 1.49935V2.33268H6.49996V1.49935C6.49996 0.999349 6.16663 0.666016 5.66663 0.666016C5.16663 0.666016 4.83329 0.999349 4.83329 1.49935V2.33268H3.16663C1.74996 2.33268 0.666626 3.41602 0.666626 4.83268V6.49935H17.3333V4.83268C17.3333 3.41602 16.25 2.33268 14.8333 2.33268Z"
                      fill="#103F5E"
                    />
                  </svg>
                </i>
              </date-picker>
            </div>
            <div class="date-time-wrappers">
              <date-picker
                id="visit_time"
                class="pre-reg-datepicker"
                :class="timeValidation ? 'is-invalid' : ''"
                :use12h="true"
                :show-second="false"
                format="hh:mm A"
                v-model="timeValue"
                value-type="date"
                type="time"
                :open.sync="open"
                :placeholder="$t('addExpectedVisitor.visitTime')"
                @change="handleTimeChange"
                :disabled="!dateValue && !timeValue"
                :disabledTime="disableTimeBeforeCurrent"
                :hour-options="availableHours"
                :minute-options="availableMinuts"
                :default-value="
                  new Date(
                    new Date(
                      new Date().toLocaleString('en-US', {
                        timeZone: this.getPreRegTimeZoneDetails,
                      })
                    ).getTime() +
                      5 * 60000
                  )
                "
              >
                <i slot="icon-calendar" v-if="!timeValue">
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.5 0.75C4.6875 0.75 0.75 4.6875 0.75 9.5C0.75 14.3125 4.6875 18.25 9.5 18.25C14.3125 18.25 18.25 14.3125 18.25 9.5C18.25 4.6875 14.3125 0.75 9.5 0.75ZM12.5625 11.25C12.3 11.6875 11.775 11.775 11.3375 11.6L9.0625 10.2875C8.8 10.1125 8.625 9.85 8.625 9.5V5.125C8.625 4.6 8.975 4.25 9.5 4.25C10.025 4.25 10.375 4.6 10.375 5.125V8.975L12.2125 10.025C12.65 10.2875 12.7375 10.8125 12.5625 11.25Z"
                      fill="#787878"
                    />
                  </svg>
                </i>
                <i slot="icon-calendar" v-if="timeValue">
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.5 0.75C4.6875 0.75 0.75 4.6875 0.75 9.5C0.75 14.3125 4.6875 18.25 9.5 18.25C14.3125 18.25 18.25 14.3125 18.25 9.5C18.25 4.6875 14.3125 0.75 9.5 0.75ZM12.5625 11.25C12.3 11.6875 11.775 11.775 11.3375 11.6L9.0625 10.2875C8.8 10.1125 8.625 9.85 8.625 9.5V5.125C8.625 4.6 8.975 4.25 9.5 4.25C10.025 4.25 10.375 4.6 10.375 5.125V8.975L12.2125 10.025C12.65 10.2875 12.7375 10.8125 12.5625 11.25Z"
                      fill="#103F5E"
                    />
                  </svg>
                </i>
              </date-picker>
            </div>
          </div>
          <p class="timezone-msg">
            <span style="font-weight: 700">{{ $t('common.notes.note') }}:</span> {{ $t('common.notes.timezone', { timezone: getPreRegTimeZoneDetails }) }}
          </p>
          <p v-if="timeValidation && dateValidation" class="time-error">
            {{ $t('preRegisteration.visitDateTimeInvalid') }}
          </p>
          <p v-else-if="timeValidation" class="time-error">
            {{ $t('addExpectedVisitor.visitTimeCantBeforeNow')}}
          </p>
          <p v-else-if="dateValidation" class="time-error">
            {{ $t('preRegisteration.visitDateTimeInvalidToday') }}
          </p>
        </div>
      </section>
    </div>
    <div
      v-if="
        !(getPreRegistrationTypes && getPreRegistrationTypes.length) &&
        !$route.query.add_visitor
      "
      class="reg-not-available-msg"
    >
     {{ $t('preRegisteration.registrationNotAvailable')}}
    </div>
    <div
      v-if="!(getPreRegistrationTypes && getPreRegistrationTypes.length)"
      class="no-usr-margin-box"
    ></div>
    <b-button
      v-if="getPreRegistrationTypes && getPreRegistrationTypes.length"
      @click="handelNextClick()"
      :disabled="!checkValidation || isLoading"
      :class="
        !checkValidation || isLoading
          ? 'next-btn dimmed-btn'
          : 'next-btn activ-btn'
      "
      size="lg"
    >
      <i
        v-if="isLoading"
        class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
      ></i>
      {{ $t('common.next') }}
    </b-button>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import usersService from "@/services/users";
import moment from "moment";

export default {
  beforeMount() {
    this.setSubmitted(false);
    this.setCommingFromLogin(null);
    this.selectDifferentUserType(null);
    this.selectNotAllowedToRegister(null);
    this.selectVisitExists(null);
    this.selectHasVisitedPage(null);
    this.setSwitch(null);
    this.setRegisterPassportAcc(null);
    this.setApiErr(null);
    this.setAllowNotSelectHost(null);
    this.setHostUserTypesExist(null);
    this.setSelectedHost(null);
    if (!this.$route.query.add_visitor) {
      this.selectRedirectLoader(true);
      this.fetchRegistrationTypes(this.$route.params.id).then((data) => {
        this.setSelectedArea(data.data.data.area);
        this.setSelectedEntity(data.data.data.entity);
        // console.log("getCompliance", this.getCompliance, this.$route.params);
        let utcDate = new Date(
          new Date().toLocaleString("en-US", { timeZone: "UTC" })
        );
        let tzDate = new Date(
          new Date().toLocaleString("en-US", {
            timeZone: this.getPreRegTimeZoneDetails,
          })
        );
        this.offset = utcDate.getTime() - tzDate.getTime();
        this.selectOffset(this.offset);
        // console.log('offsett', this.offset);
        if (!this.$route.query.comingFromPassport)
          this.selectRedirectLoader(false);
      });
    }

    if (
      this.$route.query &&
      this.$route.query.comingFromPassport &&
      this.$route.query.add_visitor
    ) {
      console.log("addddddd");

      this.selectRedirectLoader(true);
      this.setCommingFromLogin(true);

      this.getPreRegDetails({ visitUrl: this.$route.params.id }).then(
        async (res) => {
          if (
            !res.data.data.visitMetadata.is_expired ||
            !JSON.parse(res.data.data.visitMetadata.is_expired)
          ) {
            const selected_user_type = [];
            selected_user_type.push({
              name: res.data.data.userType,
              pre_registration_method: res.data.data.registrationMethod,
              id: res.data.data.user.user_type_id,
            });
            this.selectUserType(selected_user_type);

            let userExists = 1;
            if (res.data.data.user.phone || res.data.data.user.email) {
              // If either email or phone input is provided, check if the user exists
              const response = await usersService.checkIfUserExists(
                res.data.data.user.email,
                res.data.data.user.phone
              );
              const { data } = response; // Destructure data from the response
              userExists = !data; // Set userExists based on whether data is found
            }

            // Prepare payload for checking custom fields API
            const checkCustomFieldsApiPayload = {
              ...this.sectionPayload,
              phone: res.data.data.user.phone
                ? encodeURIComponent(res.data.data.user.phone)
                : "",
              email: res.data.data.user.email
                ? encodeURIComponent(res.data.data.user.email)
                : "",
              user_type_id: selected_user_type[0].id,
              area_id: res.data.data.area.id,
              visit_date: this.getVisitDate
                ? moment(new Date(this.getVisitDate)).format("YYYY-MM-DD")
                : "",
              visit_time: this.getVisitTime
                ? moment(this.getVisitTime).format("HH:mm:ss")
                : "",
              expectedDateTime: res.data.data.expectedDateTime,
              is_new_user: userExists ? 1 : 0,
            };

            // Fetch expected visit custom fields
            const { data: sections } =
              await usersService.getExpectedVisitCustomFields(
                checkCustomFieldsApiPayload
              );

            // Update sections
            this.setSections(sections);
            this.$emit("updateShowSections", !!sections.length);

            await new Promise((resolve) =>
              setTimeout(() => {
                resolve();
              }, 100)
            );

            if (
              (((!res.data.data.visitMetadata.is_confirmed ||
                !JSON.parse(res.data.data.visitMetadata.is_confirmed)) &&
                res.data.data.user.image &&
                res.data.data.validations.is_image_required) ||
                ((!res.data.data.visitMetadata.is_confirmed ||
                  !JSON.parse(res.data.data.visitMetadata.is_confirmed)) &&
                  !res.data.data.validations.is_image_required)) &&
              !sections.length
            ) {
              console.log("confirm");
              this.confirmExpectedVisitPassport();
            } else if (
              !res.data.data.visitMetadata.is_confirmed ||
              !JSON.parse(res.data.data.visitMetadata.is_confirmed)
            ) {
              console.log("confirm else");
              this.$emit("next", false);
              this.selectRedirectLoader(false);
            }
          }
        }
      );
    } else if (this.$route.query && this.$route.query.comingFromPassport) {
      const preReg = JSON.parse(this.$route.query.preRegData);
      this.toggleValue = preReg.user_type_id;
      this.dateValue = new Date(preReg.visit_date);
      this.timeValue = new Date(this.getVisitTime);
      this.selectRedirectLoader(true);
      this.setCommingFromLogin(true);
    }
  },
  data() {
    return {
      offset: null,
      daysDiff: null,
      isLoading: false,
      checkValidation: false,
      timeValidation: false,
      dateValidation: false,
      toggleValue: null,
      dateValue: null,
      timeValue: null,
      selected_user_type: [],
      pre_registration_method: null,
      open: null,
    };
  },
  watch: {
    getJourneyFlowId(flowId) {
      if (flowId) this.getJourneyFlowCompliance(flowId);
    },
    getPreRegistrationTypes(types) {
      // console.log("wttt", types);
      if (
        this.$route.query &&
        this.$route.query.comingFromPassport &&
        !this.$route.query.add_visitor
      ) {
        this.selected_user_type = [];
        const preReg = JSON.parse(this.$route.query.preRegData);
        const type = types.find((item) => item.id == preReg.user_type_id);
        this.selected_user_type.push(type);
        this.selectUserType(this.selected_user_type);
        this.getHostSettings({
          user_type_id: this.selected_user_type[0].id,
          journey_id: this.getJourneyId,
        });

        this.getValidateUserType({
          key: this.$route.query.email ? "email" : "phone",
          value: this.$route.query.email
            ? decodeURIComponent(this.$route.query.email).replace(" ", "+")
            : decodeURIComponent(this.$route.query.phone),
          entity_id: this.getSelectedUserType[0].entity_id,
        }).then(() => {
          // console.log("then", data, this.getDifferentUserType);
          setTimeout(() => {
            console.log(
              "getNotAllowedToRegister mount",
              this.getNotAllowedToRegister
            );
            if (this.getNotAllowedToRegister) {
              this.$emit("next");
              this.selectRedirectLoader(false);
            } else {
              this.checkVisitExists({
                data: this.$route.query,
              }).then(() => {
                setTimeout(() => {
                  if (this.getVisitExists) {
                    this.isLoading = false;
                    this.selectRedirectLoader(false);
                    // console.log("visitExists", this.getVisitExists);
                    this.$emit("next");
                  } else {
                    const obj = {
                      passport_id: null,
                      entity_id: this.getSelectedUserType[0].entity_id,
                    };
                    if (this.$route.query.encId) {
                      obj.passport_id = decodeURIComponent(
                        this.$route.query.encId
                      );
                    }
                    if (this.$route.query.email) {
                      obj.email = decodeURIComponent(
                        this.$route.query.email
                      ).replace(" ", "+");
                    }
                    if (this.$route.query.phone) {
                      obj.phone = decodeURIComponent(this.$route.query.phone);
                    }
                    this.checkUserEntity(obj).then(() => {
                      setTimeout(async () => {
                        try {
                          let userExists = 1;
                          if (
                            this.$route.query.phone ||
                            this.$route.query.email
                          ) {
                            // If either email or phone input is provided, check if the user exists
                            const response =
                              await usersService.checkIfUserExists(
                                this.$route.query.email,
                                this.$route.query.phone
                              );
                            const { data } = response; // Destructure data from the response
                            userExists = !data; // Set userExists based on whether data is found
                          }
                          // Prepare payload for checking custom fields API
                          const checkCustomFieldsApiPayload = {
                            user_type_id: decodeURIComponent(
                              this.getSelectedUserType[0]?.id
                            ),
                            area_id: this.getPreRegAreaDetails.id,
                            phone: this.$route.query.phone
                              ? encodeURIComponent(this.$route.query.phone)
                              : "",
                            email: this.$route.query.email
                              ? encodeURIComponent(this.$route.query.email)
                              : "",
                            visit_date: this.getVisitDate
                              ? moment(new Date(this.getVisitDate)).format(
                                  "YYYY-MM-DD"
                                )
                              : "",
                            visit_time: this.getVisitTime
                              ? moment(this.getVisitTime).format("HH:mm:ss")
                              : "",
                            expectedDateTime: this.getPreRegistrationData
                              ? this.getPreRegistrationData.expectedDateTime
                              : "",
                            is_new_user: userExists ? 1 : 0,
                          };

                          // Fetch expected visit custom fields
                          const { data: sections } =
                            await usersService.getExpectedVisitCustomFields(
                              checkCustomFieldsApiPayload
                            );

                          // Update sections and emit 'next' event
                          this.setSections(sections || []);
                          this.$emit("updateShowSections", !!sections.length);

                          await new Promise((resolve) =>
                            setTimeout(() => {
                              resolve();
                            }, 100)
                          );

                          // Return early if there are no sections to process further
                          // if (sections.length) {
                          //   this.selectFirstName(decodeURIComponent(this.$route.query.first_name));
                          //   this.selectLastName(decodeURIComponent(this.$route.query.last_name));
                          //   this.selectEmail(decodeURIComponent(this.$route.query.email));
                          //   this.setRegisterPassportAcc(true);
                          //   this.setCommingFromLogin(true);
                          //   if (decodeURIComponent(this.$route.query.phone)) {
                          //     this.selectPhone(`${decodeURIComponent(this.$route.query.phone)}`);
                          //   } else {
                          //     this.selectPhone(null);
                          //   }
                          //   return;
                          // }
                          if (this.getDifferentUserType) {
                            console.log(
                              "difff mount",
                              this.getDifferentUserType
                            );
                            this.$emit("next");
                            this.selectRedirectLoader(false);
                          } else if (
                            ((this.$route.query.comingFromPassport &&
                              this.$route.query.image &&
                              this.getCompliance.is_image_required) ||
                              !this.getCompliance.is_image_required) &&
                            (!this.getTouchModeStatus ||
                              !this.getHostUserTypesExist) &&
                            !sections.length
                          ) {
                            console.log("finishhh vis");
                            this.$emit("finish");
                          } else {
                            console.log("emit next");
                            this.$emit("next");
                            this.selectRedirectLoader(false);
                          }
                        } catch (error) {
                          console.error("An error occurred:", error);
                        }
                      }, 3000);
                    });
                  }
                }, 3000);
              });
            }
          }, 3000);
        });
      }
    },
    pre_registration_method() {
      this.handelNextStep();
    },
    timeValue() {
      this.handelNextStep();
    },
    dateValue() {
      this.handelNextStep();
    },
  },
  computed: {
    ...mapGetters("userType", [
      "getPreRegistrationTypes",
      "getPreRegAreaDetails",
      "getPreRegEntityDetails",
      "getPreRegTimeZoneDetails",
      "getJourneyId",
      "getTouchModeStatus",
      "getHostUserTypesExist",
      "getPreRegistrationData",
    ]),
    ...mapGetters("preRegistration", [
      "getCompliance",
      "getHasVisitedPage",
      "getSelectedUserType",
      "getDifferentUserType",
      "getNotAllowedToRegister",
      "getVisitExists",
      "getEmail",
      "getPhone",
      "getVisitTime",
      "getVisitDate",
      "getRegisterPassportAcc",
      "getJourneyFlowId"
    ]),
    availableHours: function () {
      let todayDate = new Date(
        new Date().toLocaleString("en-US", {
          timeZone: this.getPreRegTimeZoneDetails,
        })
      );
      let dateString = todayDate.toISOString().slice(0, 10);
      this.dateValue?.setHours(12);
      if (this.dateValue?.toISOString().slice(0, 10) === dateString) {
        let cTime = todayDate.getHours();
        const arr = this.range(cTime, 23);
        const hrsArr = [];
        arr.map((hours) => {
          if (!hrsArr.includes(hours % 12))
            hrsArr.push(hours % 12 ? hours % 12 : 0);
        });
        return hrsArr;
      }
      return this.range(0, 23);
    },

    availableMinuts: function () {
      let todayDate = new Date(
        new Date().toLocaleString("en-US", {
          timeZone: this.getPreRegTimeZoneDetails,
        })
      );
      let dateString = todayDate.toISOString().slice(0, 10);
      if (this.dateValue?.toISOString().slice(0, 10) === dateString) {
        let cTime = todayDate.getHours();
        let selectedHour = this.timeValue?.getHours();
        if (cTime === selectedHour) {
          return this.range(todayDate.getMinutes() + 5, 59);
        }
      }
      return this.range(0, 59);
    },
  },
  methods: {
    range: (start, end) => {
      return Array.from({ length: end - start + 1 }, (_, i) => i + start);
    },
    ...mapActions("userType", [
      "fetchRegistrationTypes",
      "getHostSettings",
      "setAllowNotSelectHost",
      "setHostUserTypesExist",
    ]),
    ...mapActions("preRegistration", [
      "selectUserType",
      "selectVisitDate",
      "selectVisitTime",
      "setSelectedArea",
      "setSelectedEntity",
      "selectDifferentUserType",
      "selectNotAllowedToRegister",
      "selectVisitExists",
      "selectHasVisitedPage",
      "getValidateUserType",
      "checkUserEntity",
      "checkVisitExists",
      "setCommingFromLogin",
      "selectRedirectLoader",
      "setSwitch",
      "setRegisterPassportAcc",
      "selectDaysDiff",
      "selectOffset",
      "setApiErr",
      "setSelectedHost",
      "confirmExpectedVisitPassport",
      "getPreRegDetails",
      "setSubmitted",
      "setSections",
      "setJourneyFlowId",
      "getJourneyFlowCompliance"
    ]),
    selectNextThreeDay(emit) {
      const start = new Date();
      const end = new Date();
      end.setTime(end.getTime() + 3 * 24 * 3600 * 1000);
      const date = [start, end];
      emit(date);
    },
    handleTimeChange(value, type) {
      if (type === "second") {
        this.open = false;
      }
      const utcTime = new Date(this.timeValue);
      utcTime.setTime(this.timeValue.getTime() + this.offset); // today date utc
      const dateDiff =
        Date.parse(moment(new Date(this.timeValue)).format("YYYY-MM-DD")) -
        Date.parse(moment(utcTime).format("YYYY-MM-DD"));
      this.daysDiff = dateDiff / (60 * 60 * 24 * 1000);
      // console.log('daysDiff', this.daysDiff);
      this.selectDaysDiff(this.daysDiff);

      this.handelNextStep();
    },
    handelClick(type) {
      console.log("handleclick", type);
      this.selected_user_type = [];
      this.toggleValue = type.id;
      this.selected_user_type.push(type);
      this.pre_registration_method =
        this.selected_user_type[
          this.selected_user_type?.length - 1
        ].pre_registration_method;

      const flowId = type.pivot?.journey_flow_id ? type.pivot.journey_flow_id : type.journey_flow_id;
      this.setJourneyFlowId(flowId);
      this.$emit("updateUserTypeId", this.toggleValue);
      this.handelNextStep();
    },
    handelNextStep() {
      console.log("handelNextStep", this.selected_user_type);
      this.timeValidation = false;
      this.dateValidation = false;
      const { dateValue, timeValue } = this;
      if (this.selected_user_type.length == 0) {
        this.checkValidation = false;
        return;
      }
      if (dateValue && timeValue) {
        this.checkValidation = true;
      } else {
        this.checkValidation = false;
      }

      // if (
      //   pre_registration_method === "REGISTRATION_ALLOWED" &&
      //   timeValue &&
      //   dateValue
      // ) {
      //   this.checkValidation = true;
      // } else
      // if (
      //   pre_registration_method === "REGISTRATION_ALLOWED" &&
      //   !dateValue &&
      //   !timeValue
      // ) {
      //   this.checkValidation = true;
      // } else if (
      //   (pre_registration_method === "PRE_REGISTERED_WITH_APPROVAL_REQUIRED" ||
      //     pre_registration_method ===
      //       "PRE_REGISTRATION_WITH_APPROVAL_REQUIRED" ||
      //     pre_registration_method === "PRE_REGISTERED_ONLY") &&
      //   dateValue &&
      //   timeValue
      // ) {
      //   this.checkValidation = true;
      // } else {
      //   this.checkValidation = false;
      // }
    },
    async handelNextClick() {
      let todayDate = new Date(
        new Date().toLocaleString("en-US", {
          timeZone: this.getPreRegTimeZoneDetails,
        })
      );
      let selectedDateTime = this.dateValue;
      selectedDateTime?.setHours(
        this.timeValue?.getHours(),
        this.timeValue?.getMinutes(),
        this.timeValue?.getSeconds()
      );

      // date validations
      if (
        (!this.dateValue && this.timeValue) ||
        (this.dateValue &&
          moment(new Date(this.dateValue)).format("YYYY-MM-DD") <
            moment(todayDate).format("YYYY-MM-DD"))
      ) {
        // this.checkValidation = false;
        this.dateValidation = true;
      }

      // time validation
      if (this.dateValue && !this.timeValue) {
        // this.checkValidation = false;
        this.timeValidation = true;
      }
      // let dateString = todayDate.toISOString().slice(0, 10);
      if (
        moment(new Date(this.dateValue)).format("YYYY-MM-DD") <=
        moment(todayDate).format("YYYY-MM-DD")
      ) {
        let cHours = todayDate.getHours();
        let cMinutes = todayDate.getMinutes() + 5;
        if (cHours === this.timeValue?.getHours()) {
          if (this.timeValue?.getMinutes() < cMinutes) {
            // this.checkValidation = false;
            this.timeValidation = true;
          }
        } else if (this.timeValue?.getHours() < cHours) {
          // this.checkValidation = false;
          this.timeValidation = true;
        }
      }

      if (this.dateValidation || this.timeValidation) return;
      // if (
      //   this.pre_registration_method !== "REGISTRATION_ALLOWED" &&
      //   selectedDateTime < todayDate
      // ) {
      //   this.dateValidation = false;
      //   this.timeValidation = false;
      //   return;
      // }
      this.selectUserType(this.selected_user_type);
      this.getHostSettings({
        user_type_id: this.selected_user_type[0].id,
        journey_id: this.getJourneyId,
      });
      const selectedDateStamp = Date.parse(
        moment(this.dateValue).format("YYYY-MM-DD")
      );
      let selectedDate;
      if (this.daysDiff != 0)
        selectedDate = new Date(
          selectedDateStamp - this.daysDiff * 24 * 60 * 60 * 1000
        );
      this.selectVisitDate(this.daysDiff != 0 ? selectedDate : this.dateValue);
      const utcTime = new Date(this.timeValue);
      utcTime.setTime(this.timeValue.getTime() + this.offset);
      this.selectVisitTime(utcTime);

      if (this.$route.query && this.$route.query.comingFromPassport) {
        this.isLoading = true;
        // const user = JSON.parse(this.$route.query.user);

        await this.getValidateUserType({
          key: this.$route.query.email ? "email" : "phone",
          value: this.$route.query.email
            ? decodeURIComponent(this.$route.query.email).replace(" ", "+")
            : decodeURIComponent(this.$route.query.phone),
          entity_id: this.getSelectedUserType[0].entity_id,
        }).then(() => {
          // console.log("then", data, this.getDifferentUserType);
          setTimeout(() => {
            console.log(
              "getNotAllowedToRegister",
              this.getNotAllowedToRegister
            );
            if (this.getNotAllowedToRegister) {
              this.isLoading = false;
              this.$emit("next");
            } else {
              this.checkVisitExists({
                data: this.$route.query,
              }).then(() => {
                setTimeout(() => {
                  if (this.getVisitExists) {
                    this.isLoading = false;
                    // console.log("visitExists", this.getVisitExists);
                    this.$emit("next");
                  } else {
                    const obj = {
                      passport_id: null,
                      entity_id: this.getSelectedUserType[0].entity_id,
                    };
                    if (this.$route.query.encId) {
                      obj.passport_id = decodeURIComponent(
                        this.$route.query.encId
                      );
                    }
                    if (this.$route.query.email) {
                      obj.email = decodeURIComponent(
                        this.$route.query.email
                      ).replace(" ", "+");
                    }
                    if (this.$route.query.phone) {
                      obj.phone = decodeURIComponent(this.$route.query.phone);
                    }
                    this.checkUserEntity(obj).then(() => {
                      setTimeout(async () => {
                        let userExists = 1;
                        if (
                          this.$route.query.phone ||
                          this.$route.query.email
                        ) {
                          // If either email or phone input is provided, check if the user exists
                          const response = await usersService.checkIfUserExists(
                            this.$route.query.email,
                            this.$route.query.phone
                          );
                          const { data } = response; // Destructure data from the response
                          userExists = !data; // Set userExists based on whether data is found
                        }
                        // Prepare payload for checking custom fields API
                        const checkCustomFieldsApiPayload = {
                          user_type_id: decodeURIComponent(
                            this.getSelectedUserType[0]?.id
                          ),
                          area_id: this.getPreRegAreaDetails.id,
                          phone: this.$route.query.phone
                            ? encodeURIComponent(this.$route.query.phone)
                            : "",
                          email: this.$route.query.email
                            ? encodeURIComponent(this.$route.query.email)
                            : "",
                          visit_date: this.getVisitDate
                            ? moment(new Date(this.getVisitDate)).format(
                                "YYYY-MM-DD"
                              )
                            : "",
                          visit_time: this.getVisitTime
                            ? moment(this.getVisitTime).format("HH:mm:ss")
                            : "",
                          is_new_user: userExists ? 1 : 0,
                        };

                        // Fetch expected visit custom fields
                        const { data: sections } =
                          await usersService.getExpectedVisitCustomFields(
                            checkCustomFieldsApiPayload
                          );

                        // Update sections and emit 'next' event
                        this.setSections(sections || []);
                        this.$emit("updateShowSections", !!sections.length);

                        await new Promise((resolve) =>
                          setTimeout(() => {
                            resolve();
                          }, 100)
                        );
                        if (this.getDifferentUserType) {
                          this.isLoading = false;
                          console.log("difff", this.getDifferentUserType);
                          this.$emit("next");
                        } else if (
                          ((this.$route.query.comingFromPassport &&
                            this.$route.query.image &&
                            this.getCompliance.is_image_required) ||
                            !this.getCompliance.is_image_required) &&
                          (!this.getTouchModeStatus ||
                            !this.getHostUserTypesExist) &&
                          !sections.length
                        ) {
                          // setTimeout(() => {
                          this.isLoading = false;
                          console.log("finishhh login");
                          this.$emit("finish");
                          // }, 3000);
                        } else {
                          this.isLoading = false;
                          this.$emit("next");
                        }
                      }, 3000);
                    });
                  }
                }, 3000);
              });
            }
          }, 3000);
        });
      } else {
        console.log("not login");
        this.setCommingFromLogin(false);
        if (this.getHasVisitedPage && (this.getEmail || this.getPhone)) {
          await this.getValidateUserType({
            key: this.getEmail ? "email" : "phone",
            value: this.getEmail ? this.getEmail : this.getPhone,
            entity_id: this.getSelectedUserType[0].entity_id,
          }).then(() => {
            this.isLoading = true;
            setTimeout(() => {
              if (this.getNotAllowedToRegister) {
                this.isLoading = false;
                this.$emit("next");
              } else {
                this.checkVisitExists({
                  data: this.$route.query,
                }).then(() => {
                  setTimeout(() => {
                    if (this.getVisitExists) {
                      this.isLoading = false;
                      // console.log("visitExists", this.getVisitExists);
                      this.$emit("next");
                    } else {
                      const obj = {
                        passport_id: null,
                        entity_id: this.getSelectedUserType[0].entity_id,
                      };
                      if (this.getEmail) {
                        obj.email = this.getEmail;
                      }
                      if (this.getPhone) {
                        obj.phone = this.getPhone;
                      }
                      this.checkUserEntity(obj)
                        .then(() => {
                          this.isLoading = true;
                          setTimeout(async () => {
                            this.isLoading = false;

                            let userExists = 1;
                            if (
                              this.$route.query.phone ||
                              this.$route.query.email
                            ) {
                              // If either email or phone input is provided, check if the user exists
                              const response =
                                await usersService.checkIfUserExists(
                                  this.$route.query.email,
                                  this.$route.query.phone
                                );
                              const { data } = response; // Destructure data from the response
                              userExists = !data; // Set userExists based on whether data is found
                            }
                            // Prepare payload for checking custom fields API
                            const checkCustomFieldsApiPayload = {
                              user_type_id: decodeURIComponent(
                                this.getSelectedUserType[0]?.id
                              ),
                              area_id: this.getPreRegAreaDetails.id,
                              phone: this.$route.query.phone
                                ? encodeURIComponent(this.$route.query.phone)
                                : "",
                              email: this.$route.query.email
                                ? encodeURIComponent(this.$route.query.email)
                                : "",
                              visit_date: this.getVisitDate
                                ? moment(new Date(this.getVisitDate)).format(
                                    "YYYY-MM-DD"
                                  )
                                : "",
                              visit_time: this.getVisitTime
                                ? moment(this.getVisitTime).format("HH:mm:ss")
                                : "",
                              is_new_user: userExists ? 1 : 0,
                            };

                            // Fetch expected visit custom fields
                            const { data: sections } =
                              await usersService.getExpectedVisitCustomFields(
                                checkCustomFieldsApiPayload
                              );

                            // Update sections and emit 'next' event
                            this.setSections(sections || []);
                            this.$emit("updateShowSections", !!sections.length);

                            await new Promise((resolve) =>
                              setTimeout(() => {
                                resolve();
                              }, 100)
                            );
                            if (this.getDifferentUserType) {
                              this.$emit("next");
                            } else if (
                              this.getHasVisitedPage &&
                              !this.getCompliance.is_image_required &&
                              this.getRegisterPassportAcc &&
                              (!this.getTouchModeStatus ||
                                !this.getHostUserTypesExist) &&
                              !sections.length
                            ) {
                              this.$emit("finish");
                            } else {
                              this.$emit("next");
                            }
                          }, 3000);
                        })
                        .catch(() => {
                          this.isLoading = false;
                        });
                    }
                  }, 3000);
                });
              }
            }, 3000);
          });
        } else if (
          this.getHasVisitedPage &&
          !this.getCompliance.is_image_required &&
          this.getRegisterPassportAcc &&
          (!this.getTouchModeStatus || !this.getHostUserTypesExist)
        )
          this.$emit("finish");
        else this.$emit("next");
      }
    },
    disableDateBeforeCurrent(date) {
      let cDate = new Date(
        new Date().toLocaleString("en-US", {
          timeZone: this.getPreRegTimeZoneDetails,
        })
      );
      let currentYear = cDate.getFullYear();
      let currentMonth = cDate.getMonth();
      let currentDay = cDate.getDate();
      return date < new Date(currentYear, currentMonth, currentDay);
    },
    disableTimeBeforeCurrent(date) {
      const time = new Date(
        new Date(
          new Date().toLocaleString("en-US", {
            timeZone: this.getPreRegTimeZoneDetails,
          })
        ).getTime() +
          4 * 60000
      );
      const after5Mins = moment(new Date(time)).format("HH:mm:ss");
      const todayDate = moment(
        new Date(
          new Date().toLocaleString("en-US", {
            timeZone: this.getPreRegTimeZoneDetails,
          })
        )
      ).format("YYYY-MM-DD");
      const selectedTime = moment(new Date(date)).format("HH:mm:ss");
      return (
        moment(new Date(this.dateValue)).format("YYYY-MM-DD") == todayDate &&
        selectedTime < after5Mins
      );
    },
  },
};
</script>
<style lang="scss">
.timezone-msg {
  font-size: 12px;
  line-height: 17px;
  text-align: start;
  letter-spacing: 0.25px;
  color: #939393;
  opacity: 0.8;
  margin-top: 16px;
  margin-inline-start: 40px;
  margin-bottom: 0px !important;
}
.vue-form-wizard .wizard-tab-content {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  min-height: 0px !important;
}
</style>
<style lang="scss" scoped>
.pre-register-wrapper {
  position: relative;

  .pre-register-form {
    margin-top: 65px !important;
    margin-bottom: 108px !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 491px;

    text-align: center;
    box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
    border-radius: 26px;
    background: #ffffff;

    .pre-reg-head-tab1 {
      display: flex;
      flex-direction: column;
      justify-content: center;

      margin-top: 49px !important;
      text-align: center;
      background-color: #fff;
    }
    .wizard-tab-content {
      padding-top: 0 !important;
    }
  }
  .no-usr-pre-reg-head-tab1 {
    margin-top: 84px;
  }
  .no-usr-margin-box {
    height: 160px;
  }
  .logo {
    display: block;
    width: 116px;
    height: 22px;
    margin: 0 auto;
    margin-bottom: 28px;
    img {
      width: 86px;
      height: 16px;
    }
  }
  .welcome-msg {
    font-weight: 500;
    font-size: 17px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.25px;
    color: #000000;
    margin-bottom: 21px;
  }
  .reg-msg-tab1 {
    font-size: 14px;

    font-weight: 400;
    text-align: center;
    color: #666666;
    margin-bottom: 61px;
  }
  .select-type-msg {
    font-size: 14px;
    font-weight: 700;
    line-height: 17px;
    text-align: start;
    margin-bottom: 31px;
    color: #787878;
    padding-inline-start: 55px;
  }
  .btns-grid {
    text-align: start;
    margin: 0 22px 0 22px;
  }
  .btns-grid button {
    margin-top: 0;
    margin-inline-end: 0;
    margin-bottom: 16px;
    margin-inline-start: 16px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);

    opacity: 0.8;
    font-weight: 500;
    line-height: 17px;
    text-align: center;
    padding: 10px 17px;
  }
  .h-line-tab1 {
    margin: 38px auto 38px auto;
    opacity: 0.08;
    width: 415px;
    height: 1px;
    background: #000;
  }
  .date-time-lable {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.25px;
    color: #787878;
    text-align: start;
    margin-bottom: 31px;
    padding-inline-start: 53px;
  }
  .date-piker-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .time-error {
    font-size: 14px;
    font-weight: 500;
    line-height: 19px;
    letter-spacing: 0.25px;
    text-align: center;
    color: #f46a6a;
    margin-top: 20px;
  }
  .date-p {
    margin-inline-end: 15px;
  }
  .date-time-wrappers {
    width: 200px !important;
    height: 55px !important;

    .selected-date-lable {
      margin-bottom: -3px;
      text-align: start;
      background-color: #f2f2f2;
      padding-top: 8px;
      padding-inline-start: 12px;
      font-size: 10px;
      font-weight: 700;
      color: #103f5e;
    }
    .invaled-top-half {
      border: 1.5px solid #f46a6a;
      border-bottom: none;
      border-radius: 4px 4px 0 0;
    }
  }
  .next-btn {
    display: block;
    width: 415px;
    height: 44px;

    margin: 0 auto 38px auto;
    border-radius: 18.5px;

    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    /* identical to box height, or 106% */

    text-align: center;
    letter-spacing: 0.25px;
    text-transform: uppercase;
  }
  .dimmed-btn {
    background-color: #96abb8 !important;
    color: #ffffff !important;
    cursor: not-allowed;
    border: none;
  }
  .activ-btn {
    background-color: #103f5e;
    pointer-events: auto;
    border: none;
  }
  .reg-not-available-msg {
    font-weight: 400;
    font-size: 14px;
    line-height: 27px;
    text-align: center;
    letter-spacing: 0.25px;
    color: #666666;
    width: 245px;
    text-align: center;
    margin: 195px auto;
  }
  .is-invalid {
    border: 1.5px solid #f46a6a;
    border-radius: 4px;
  }
}

div#visit_date {
  ::placeholder {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    /* identical to box height, or 121% */

    letter-spacing: 0.25px;

    color: #787878;
  }
}
div#visit_time {
  ::placeholder {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    /* identical to box height, or 121% */

    letter-spacing: 0.25px;

    color: #787878;
  }
}
button.btn.btn-dark.rounded-pill {
  background: #000000 !important;
  border: none;

  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height, or 121% */

  text-align: center;
  letter-spacing: 0.25px;

  color: #ffffff !important;
}
@media (max-width: 992px) {
  .pre-register-wrapper {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    .pre-register-form {
      margin-top: 0px !important;
      margin-bottom: 0px !important;
      display: flex;
      flex-direction: column;
      justify-content: center;
      // width: 100%;
      width: 360px;
      // height: 100%;
      // max-height: 814px;
      text-align: center;
      // margin-top:40px;
      background-color: #ffffff;
      border-radius: 0px;

      .pre-reg-head-tab1 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        max-width: 491px;
        text-align: center;
        background-color: #fff;
        margin-top: 84px;
      }
      .wizard-tab-content {
        padding-top: 0 !important;
      }
    }
    .no-usr-pre-reg-head-tab1 {
      margin-top: 84px;
    }
    .no-usr-margin-box {
      height: 160px;
    }
    .logo {
      display: block;
      width: 116px;
      height: 22px;
      margin: 0 auto;
      margin-bottom: 24px;
      img {
        width: 116px;
        height: 22px;
      }
    }
    .welcome-msg {
      font-weight: 500;
      font-size: 17px;
      line-height: 20px;
      text-align: center;
      letter-spacing: 0.25px;
      color: #000000;
      margin-bottom: 21px;
    }
    .reg-msg-tab1 {
      font-size: 14px;

      font-weight: 400;
      text-align: center;
      color: #666666;
      margin-bottom: 61px;
    }
    .select-type-msg {
      font-size: 14px;
      font-weight: 700;
      line-height: 17px;
      text-align: start;
      margin-bottom: 31px;
      color: #787878;
      padding-inline-start: 40px;
    }
    .btns-grid {
      text-align: start;
      margin: 0 10px 0 10px;
    }
    .btns-grid button {
      margin-top: 0;
      margin-inline-end: 0;
      margin-bottom: 16px;
      margin-inline-start: 16px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.87);

      opacity: 0.8;
      font-weight: 500;
      line-height: 17px;
      text-align: center;
      padding: 10px 17px;
    }
    .h-line-tab1 {
      margin: 44px auto 25px auto;
      opacity: 0.08;
      width: 309px;
      height: 1px;
      background: #000;
    }
    .date-time-lable {
      font-weight: 700;
      font-size: 14px;
      line-height: 17px;
      letter-spacing: 0.25px;
      color: #787878;
      text-align: start;
      margin-bottom: 31px;
      padding-inline-start: 40px;
    }
    .date-piker-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .time-error {
      font-size: 14px;
      font-weight: 500;
      line-height: 19px;
      letter-spacing: 0.25px;
      text-align: center;
      color: #f46a6a;
      margin-top: 20px;
    }
    .date-p {
      margin-inline-end: 15px;
    }
    .date-time-wrappers {
      width: 147px !important;
      height: 49px !important;

      .selected-date-lable {
        margin-bottom: -3px;
        text-align: start;
        background-color: #f2f2f2;
        padding-top: 8px;
        padding-inline-start: 12px;
        font-size: 10px;
        font-weight: 700;
        color: #103f5e;
      }
      .invaled-top-half {
        border: 1.5px solid #f46a6a;
        border-bottom: none;
        border-radius: 4px 4px 0 0;
      }
    }
    .next-btn {
      display: block;
      width: 309px;
      height: 37px;

      margin: 0 auto 80px auto;
      border-radius: 18.5px;

      font-weight: 500;
      font-size: 16px;
      line-height: 17px;
      /* identical to box height, or 106% */

      text-align: center;
      letter-spacing: 0.25px;
      text-transform: uppercase;
    }
    .dimmed-btn {
      background-color: #96abb8 !important;
      color: #ffffff !important;
      cursor: not-allowed;
      border: none;
    }
    .activ-btn {
      background-color: #103f5e;
      pointer-events: auto;
      border: none;
    }
    .reg-not-available-msg {
      font-weight: 400;
      font-size: 14px;
      line-height: 27px;
      text-align: center;
      letter-spacing: 0.25px;
      color: #666666;
      width: 245px;
      text-align: center;
      margin: 195px auto;
    }
    .is-invalid {
      border: 1.5px solid #f46a6a;
      border-radius: 4px;
    }
  }

  div#visit_date {
    ::placeholder {
      font-weight: 700;
      font-size: 14px;
      line-height: 17px;
      /* identical to box height, or 121% */

      letter-spacing: 0.25px;

      color: #787878;
    }
  }
  div#visit_time {
    ::placeholder {
      font-weight: 700;
      font-size: 14px;
      line-height: 17px;
      /* identical to box height, or 121% */

      letter-spacing: 0.25px;

      color: #787878;
    }
  }
  button.btn.btn-dark.rounded-pill {
    background: #000000 !important;
    border: none;

    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    /* identical to box height, or 121% */

    text-align: center;
    letter-spacing: 0.25px;

    color: #ffffff !important;
  }
}
</style>
